export function getAccessToken(state) {
    return state.AuthenticationReducer.token;
}